import { useAuth0 } from '@auth0/auth0-react';
import { useUserContext } from 'context/UserContextProvider';
import { useEffect } from 'react';

import { LoadingSpinner } from '../components/LoadingSpinner';
import config from '../config';

export const LogoutPage = () => {
  const { logout } = useAuth0();
  const { logout: contextLogout } = useUserContext();

  useEffect(() => {
    contextLogout();
    logout({ returnTo: config.baseUrl.toString() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <LoadingSpinner />;
};
